import ReactPixel from 'react-facebook-pixel';
import TiktokPixel from 'tiktok-pixel';

import config from '../../constants/config';

const initTikTokPixel = (debug = false) => {
  // https://github.com/ertemishakk/tiktok-pixel/
  if (config.TIKTOK_PIXEL) {
    TiktokPixel.init(config.TIKTOK_PIXEL, {}, { debug }) &&
      TiktokPixel.pageView();
  }
};

const injectTrkScripts = () => {
  require('./scripts/snapChat.js');
  require('./scripts/bing.js');
  require('./scripts/verizon.js');
  require('./scripts/taboola.js');
  require('./scripts/raygun.js');
};

// runs on all no matter the consent
export const anyConsent = (debug = false) => {
  //
};

// only for non-mandatory consent countries & territories
export const nonRequiredConsent = (debug = false) => {
  injectTrkScripts();
  if (
    Array.isArray(config.FB_TRACKING_PIXEL_ID) &&
    config.FB_TRACKING_PIXEL_ID.length > 0
  ) {
    for (let index = 0; index < config.FB_TRACKING_PIXEL_ID.length; index++) {
      const fbPixel = config.FB_TRACKING_PIXEL_ID[index];
      ReactPixel.init(fbPixel, {}, { debug });
    }
    ReactPixel.pageView();
  }
  initTikTokPixel(debug);
};

// only for consent mandatory countries & territories
export const requiredConsentInit = (debug = false) => {
  if (
    Array.isArray(config.FB_TRACKING_PIXEL_ID) &&
    config.FB_TRACKING_PIXEL_ID.length > 0
  ) {
    for (let index = 0; index < config.FB_TRACKING_PIXEL_ID.length; index++) {
      const fbPixel = config.FB_TRACKING_PIXEL_ID[index];
      ReactPixel.init(fbPixel, {}, { debug });
    }
    ReactPixel.revokeConsent(); // it must be oustide for loop to work properly
    ReactPixel.pageView();
  }
};

export const requiredConsentAccepted = (debug = false) => {
  injectTrkScripts();
  if (config.FB_TRACKING_PIXEL_ID) {
    ReactPixel.grantConsent();
  }
  initTikTokPixel(debug);
};

export const requiredConsentDeclined = () => {
  if (config.FB_TRACKING_PIXEL_ID) {
    ReactPixel.revokeConsent();
  }
};



// WEBPACK FOOTER //
// ./src/assets/helpers/cookieConsent.js